import React from 'react';
import { Router, Route, Switch, Redirect } from 'react-router-dom';
import Navbar from '../components/Navbar/Navbar';
import Home from '../screens/Home/Home';
import Contacts from '../screens/Contacts/Contacts';
import CallForSpeakers from '../screens/CallForSpeakers/CallForSpeakers';
import SpeakersContainer from '../screens/Speakers/Speakers';
import SpeakerDetailsContainer from '../screens/SpeakerDetails/SpeakerDetails';
import ProgramContainer from '../screens/Program/Program';
import TalkDetailContainer from '../screens/TalkDetail/TalkDetail';
import LocationMap from '../screens/LocationMap/LocationMap';
// import Livestream from '../screens/Livestream/Livestream';
// import FeedbackForm from '../screens/FeedbackForm/FeedbackForm';

export const Routes = () => {
  return (
    <Route>
      <Navbar />
      <Switch>
        <Route component={Home} exact path="/" />
        <Route component={Contacts} exact path="/contacts" />
        <Route component={CallForSpeakers} exact path="/cfs" />
        <Route component={LocationMap} exact path="/location-map" />
        <Route component={SpeakersContainer} exact path="/speakers" />
        <Route component={SpeakerDetailsContainer} exact path="/speakers/:speakerId" />
        <Route component={ProgramContainer} exact path="/program" />
        <Route component={TalkDetailContainer} exact path="/program/:talkId" />
        {/* <Route component={Livestream} exact path="/livestream" /> */}
        <Route component={ProgramContainer} exact path="/workshops" />

        <Route exact path="/workshops/1">
          <Redirect to="/program/e25441da-c9eb-4e1d-a691-07254d08c9f7" />
        </Route>
        <Route exact path="/workshops/2">
          <Redirect to="/program/31894955-6d60-4f71-93a5-5564e39d5965" />
        </Route>
        <Route exact path="/workshops/3">
          <Redirect to="/program/76b23f6c-414b-453b-922e-258cd3d10955" />
        </Route>
        <Route exact path="/workshops/4">
          <Redirect to="/program/eccd48f2-1a15-4201-b4cd-45524432b4c3" />
        </Route>
        <Route exact path="/workshops/5">
          <Redirect to="/program/feca2691-92cf-44b1-9d1c-2b2633e1bb75" />
        </Route>
        <Route exact path="/workshops/6">
          <Redirect to="/program/4734fcda-f6ad-41c5-a1ae-bc7714cb637d" />
        </Route>
        <Route exact path="/workshops/7">
          <Redirect to="/program/00f45a4d-44e1-4bf7-adea-67a41afbbdb5" />
        </Route>
        <Route exact path="/workshops/8">
          <Redirect to="/program/9988d114-c400-4ebf-ac55-d621662b8fa2" />
        </Route>
        <Route exact path="/workshops/9">
          <Redirect to="/program/014ba340-b23c-466b-9971-9d63edd5ac50" />
        </Route>
        <Route exact path="/workshops/10">
          <Redirect to="/program/37504b2f-57f3-44f9-9741-4a4bfa448c06" />
        </Route>
        <Route exact path="/workshops/11">
          <Redirect to="/program/3381db4a-df73-4ca6-bef9-48411567075f" />
        </Route>
        <Route exact path="/workshops/12">
          <Redirect to="/program/57f7f201-3937-497d-b266-52d3fd96bcdc" />
        </Route>
        <Route exact path="/workshops/13">
          <Redirect to="/program/c30935f1-b1c4-4a8d-be90-d5e9f6b113ac" />
        </Route>

        {/* <Route component={FeedbackForm} exact path="/ff" /> */}
      </Switch>
    </Route>
  );
};

const RouterContainer = props => (
  <Router {...props}>
    <Routes />
  </Router>
);

export default RouterContainer;
